<template>
  <div>
    <div class="mb-6">
      <h2 class="text-xl font-semibold text-gray-300 mb-2">Opis proizvoda</h2>
      <p
        class="text-gray-400 whitespace-pre-line leading-relaxed break-words overflow-wrap-anywhere"
      >
        {{ product.description }}
      </p>
    </div>

    <div class="border-t border-gray-700 my-4"></div>

    <div class="bg-gray-700 bg-opacity-50 rounded-lg p-3 mb-6 shadow-inner">
      <h3 class="text-sm text-gray-400">Postavljen</h3>
      <p class="text-white font-medium">
        {{ formatDate(product.renewedAt || product.createdAt) }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { Product } from '@/composables/useProductDetail';

export default defineComponent({
  name: 'ProductInfo',
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
    formatDate: {
      type: Function as PropType<(date: string) => string>,
      required: true,
    },
  },
});
</script>

<style scoped>
/* Dodatne mobilne optimizacije za tekst */
@media (max-width: 768px) {
  .text-gray-400 {
    word-break: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
  }
}

@media (max-width: 480px) {
  .text-gray-400 {
    font-size: 0.875rem;
    line-height: 1.5;
    word-break: break-word;
    overflow-wrap: anywhere;
    white-space: pre-wrap;
    max-width: 100%;
    width: 100%;
  }
}
</style>
